import { isDemoSession } from './session';

/**
 * The seam. Installed as the Supabase client's `global.fetch`, which covers
 * every `.from()`, `.rpc()` and `functions.invoke()` in the app because they
 * all serialise to a URL before reaching the network.
 *
 * Kept tiny and free of imports beyond `session` on purpose: this file is
 * eager (it is referenced when the client is constructed), and the demo layer
 * proper is `import()`ed only once a session exists. `lighthouserc.js` budgets
 * are an enforcing CI gate, so a signed-in user must never pay for the demo.
 */

// Captured at module load, before anything can patch it.
const realFetch: typeof fetch = globalThis.fetch.bind(globalThis);

export const demoAwareFetch: typeof fetch = async (input, init) => {
  if (!isDemoSession()) return realFetch(input, init);
  const { handleDemoRequest } = await import('./fetch');
  return handleDemoRequest(input, init, realFetch);
};
